import { c as _c } from "react/compiler-runtime";
import MapThumbnailCaller from "@/components/pages/search/map/components/MapThumbnailCaller";
import { format } from "date-fns/format";
import RenderImage from "@/components/atoms/RenderImage";
import { cn } from "@/lib/utils";
import CardAvatar from "@/components/cardElements/CardAvatar";
import { LocationBadges } from "@/components/molecules/LocationMap/LocationBadges";
import { ReviewRow } from "@/components/atoms/ReviewRow";
import { Switch } from "@/components/ui/switch";
import { FormSwitch } from "@/components/Inputs/FormInputs/form-switch/FormSwitch";
import { PhotoPreviewGroup } from "@/components/molecules/PhotoPreviewGroup/PhotoPreviewGroup";
import { Pills } from "@/components/molecules/feature-pills/FeaturePills";
import { useRevisionDetails } from "./useRevisionDetails";
export function RevisionDetails() {
  const $ = _c(127);
  const {
    t,
    session,
    profile,
    isDemand,
    title,
    description,
    latitude,
    longitude,
    price,
    deposit,
    bedrooms,
    bathrooms,
    maxPersons,
    gender,
    roomFeatures,
    houseFeatures,
    houseRules,
    localization,
    availableFrom,
    images,
    selectedLocations,
    locationPolygons,
    associatedUnitId,
    associatedUnitTitle,
    associatedPortfolioTitle,
    associatedPropertyImages: t0
  } = useRevisionDetails();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const associatedPropertyImages = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== title) {
    t3 = <ReviewRow label={t2} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{title}</ReviewRow>;
    $[4] = t2;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("description");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = description ? <p className="line-clamp-6 sm:text-justify">{description}</p> : "-";
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <ReviewRow label={t4} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{t5}</ReviewRow>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("price");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== price || $[17] !== t7) {
    t8 = <ReviewRow label={t7} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{price}</ReviewRow>;
    $[16] = price;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== deposit || $[20] !== isDemand || $[21] !== t) {
    t9 = !isDemand && <ReviewRow label={t("deposit")}>{deposit}</ReviewRow>;
    $[19] = deposit;
    $[20] = isDemand;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== bathrooms || $[24] !== bedrooms || $[25] !== isDemand || $[26] !== t) {
    t10 = !isDemand && <><ReviewRow label={t("bedrooms")}>{bedrooms}</ReviewRow><ReviewRow label={t("bathrooms")}>{bathrooms}</ReviewRow></>;
    $[23] = bathrooms;
    $[24] = bedrooms;
    $[25] = isDemand;
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t) {
    t11 = t("availableFrom");
    $[28] = t;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== availableFrom) {
    t12 = format(availableFrom, "dd/MM/yyyy");
    $[30] = availableFrom;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = <ReviewRow label={t11} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{t12}</ReviewRow>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t) {
    t14 = t("maxPersons");
    $[35] = t;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== maxPersons || $[38] !== t14) {
    t15 = <ReviewRow label={t14} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{maxPersons}</ReviewRow>;
    $[37] = maxPersons;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = t("gender");
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const t17 = gender === "male" ? "text-sky-600" : gender === "female" ? "text-pink-600" : "";
  let t18;
  if ($[42] !== t17) {
    t18 = cn("capitalize", t17);
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== gender || $[45] !== t18) {
    t19 = <span className={t18}>{gender}</span>;
    $[44] = gender;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t16 || $[48] !== t19) {
    t20 = <ReviewRow label={t16} data-sentry-element="ReviewRow" data-sentry-source-file="RevisionDetails.tsx">{t19}</ReviewRow>;
    $[47] = t16;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== houseRules || $[51] !== t) {
    t21 = houseRules?.length > 0 && <ReviewRow label={t("houseRules")} stack={true}><Pills items={houseRules} className="sm:justify-end" /></ReviewRow>;
    $[50] = houseRules;
    $[51] = t;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== roomFeatures || $[54] !== t) {
    t22 = roomFeatures?.length > 0 && <ReviewRow label={t("roomFeatures")} stack={true}><Pills items={roomFeatures} className="sm:justify-end" /></ReviewRow>;
    $[53] = roomFeatures;
    $[54] = t;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== houseFeatures || $[57] !== t) {
    t23 = houseFeatures?.length > 0 && <ReviewRow label={t("houseFeatures")} stack={true}><Pills items={houseFeatures} className="sm:justify-end" /></ReviewRow>;
    $[56] = houseFeatures;
    $[57] = t;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== associatedPortfolioTitle || $[60] !== associatedUnitId || $[61] !== associatedUnitTitle || $[62] !== isDemand || $[63] !== t) {
    t24 = !isDemand && associatedUnitId && <ReviewRow label={t("associatedProperty")}><span className="capitalize">{associatedPortfolioTitle}{associatedUnitTitle ? ` — ${associatedUnitTitle}` : ""}</span></ReviewRow>;
    $[59] = associatedPortfolioTitle;
    $[60] = associatedUnitId;
    $[61] = associatedUnitTitle;
    $[62] = isDemand;
    $[63] = t;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== isDemand || $[66] !== latitude || $[67] !== localization || $[68] !== locationPolygons || $[69] !== longitude || $[70] !== selectedLocations || $[71] !== t) {
    t25 = isDemand ? <><ReviewRow label={t("location")}><LocationBadges locations={selectedLocations} readOnly={true} /></ReviewRow><MapThumbnailCaller polygonPrimary={locationPolygons} className="h-52 w-full rounded-lg shadow-xs" /></> : <><ReviewRow label={t("location")}><span>{localization}</span></ReviewRow><MapThumbnailCaller lat={latitude ? latitude : undefined} lng={longitude ? longitude : undefined} className="h-52 w-full rounded-lg shadow-xs" /></>;
    $[65] = isDemand;
    $[66] = latitude;
    $[67] = localization;
    $[68] = locationPolygons;
    $[69] = longitude;
    $[70] = selectedLocations;
    $[71] = t;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== images || $[74] !== isDemand || $[75] !== profile || $[76] !== t) {
    t26 = isDemand ? <div className="flex flex-col gap-3 pt-4"><span className="text-faint-foreground">{t("yourProfile")}</span><div className="flex items-center gap-3"><CardAvatar imgUrl={profile.image || ""} name={profile.name ?? undefined} className="w-12 h-12" /><div className="flex flex-col"><span className="font-semibold">{profile.name || "-"}</span><span className="text-sm text-muted-foreground line-clamp-2">{profile.bio || "-"}</span></div></div></div> : images.length > 0 && <><span className="text-faint-foreground">{t("images")}</span><div className=" grid grid-cols-4 gap-2 h-fit">{images.map(_temp)}</div></>;
    $[73] = images;
    $[74] = isDemand;
    $[75] = profile;
    $[76] = t;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  let t27;
  if ($[78] !== associatedPropertyImages || $[79] !== isDemand || $[80] !== t) {
    t27 = !isDemand && associatedPropertyImages.length > 0 && <PhotoPreviewGroup label={t("propertyPhotosLabel")} description={t("propertyPhotosDescription")} photos={associatedPropertyImages} columns={4} columnsMd={8} />;
    $[78] = associatedPropertyImages;
    $[79] = isDemand;
    $[80] = t;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] !== t25 || $[83] !== t26 || $[84] !== t27) {
    t28 = <div className="flex flex-col gap-2 justify-between">{t25}{t26}{t27}</div>;
    $[82] = t25;
    $[83] = t26;
    $[84] = t27;
    $[85] = t28;
  } else {
    t28 = $[85];
  }
  let t29;
  if ($[86] !== t10 || $[87] !== t13 || $[88] !== t15 || $[89] !== t20 || $[90] !== t21 || $[91] !== t22 || $[92] !== t23 || $[93] !== t24 || $[94] !== t28 || $[95] !== t3 || $[96] !== t6 || $[97] !== t8 || $[98] !== t9) {
    t29 = <div className="space-y-2 min-w-0">{t3}{t6}{t8}{t9}{t10}{t13}{t15}{t20}{t21}{t22}{t23}{t24}{t28}</div>;
    $[86] = t10;
    $[87] = t13;
    $[88] = t15;
    $[89] = t20;
    $[90] = t21;
    $[91] = t22;
    $[92] = t23;
    $[93] = t24;
    $[94] = t28;
    $[95] = t3;
    $[96] = t6;
    $[97] = t8;
    $[98] = t9;
    $[99] = t29;
  } else {
    t29 = $[99];
  }
  let t30;
  if ($[100] !== t) {
    t30 = t("showContacts");
    $[100] = t;
    $[101] = t30;
  } else {
    t30 = $[101];
  }
  let t31;
  if ($[102] !== t30) {
    t31 = <span className="font-semibold text-foreground">{t30}</span>;
    $[102] = t30;
    $[103] = t31;
  } else {
    t31 = $[103];
  }
  const t32 = session.data?.showContacts ?? true;
  let t33;
  if ($[104] !== t32) {
    t33 = <Switch checked={t32} disabled={true} data-sentry-element="Switch" data-sentry-source-file="RevisionDetails.tsx" />;
    $[104] = t32;
    $[105] = t33;
  } else {
    t33 = $[105];
  }
  let t34;
  if ($[106] !== t31 || $[107] !== t33) {
    t34 = <div className="flex items-center justify-between gap-4">{t31}{t33}</div>;
    $[106] = t31;
    $[107] = t33;
    $[108] = t34;
  } else {
    t34 = $[108];
  }
  let t35;
  if ($[109] !== t) {
    t35 = t("showContactsDescription");
    $[109] = t;
    $[110] = t35;
  } else {
    t35 = $[110];
  }
  let t36;
  if ($[111] !== t35) {
    t36 = <p className="text-sm text-muted-foreground">{t35}</p>;
    $[111] = t35;
    $[112] = t36;
  } else {
    t36 = $[112];
  }
  let t37;
  if ($[113] !== t34 || $[114] !== t36) {
    t37 = <div className="flex flex-col gap-2">{t34}{t36}</div>;
    $[113] = t34;
    $[114] = t36;
    $[115] = t37;
  } else {
    t37 = $[115];
  }
  let t38;
  if ($[116] !== t) {
    t38 = t("matchAlerts");
    $[116] = t;
    $[117] = t38;
  } else {
    t38 = $[117];
  }
  let t39;
  if ($[118] !== t) {
    t39 = t("matchAlertsDescription");
    $[118] = t;
    $[119] = t39;
  } else {
    t39 = $[119];
  }
  let t40;
  if ($[120] !== t38 || $[121] !== t39) {
    t40 = <FormSwitch name="matchAlertsEnabled" label={t38} description={t39} defaultChecked={true} className="mb-10" data-sentry-element="FormSwitch" data-sentry-source-file="RevisionDetails.tsx" />;
    $[120] = t38;
    $[121] = t39;
    $[122] = t40;
  } else {
    t40 = $[122];
  }
  let t41;
  if ($[123] !== t29 || $[124] !== t37 || $[125] !== t40) {
    t41 = <div className="flex flex-col gap-8" data-sentry-component="RevisionDetails" data-sentry-source-file="RevisionDetails.tsx">{t29}{t37}{t40}</div>;
    $[123] = t29;
    $[124] = t37;
    $[125] = t40;
    $[126] = t41;
  } else {
    t41 = $[126];
  }
  return t41;
}
function _temp(image, idx) {
  return <div key={idx} className="w-full col-span-1 aspect-square rounded-xl overflow-hidden border"><RenderImage className="object-cover " alt="" src={typeof image === "string" ? image : URL.createObjectURL(image)} /></div>;
}